import isDomainMatch from 'utils/isDomainMatch'

import getURLFromElem from '../getURLFromElem'

// For the time being, we're implementing this as a hard-coded list to
// pacify a very large client that can't be bothered to use
// `data-termly-placeholder-id`. If this approach catches on, then we
// should really take this configuration and make it user-configurable
// in the dashboard and return it as part of the resource-blocker
// bundle.
//
const BLOCKED_CONTENT_NOTICE_SELECTORS = {
  'easy-booking.at': '#ebFrontEndFrame',
  'herold.at': '[id^=herold-]',
  'wufoo.com': '[id^=wufoo-]',
}


export default function findPlaceholdersForNode(node) {
  const { hostname } = getURLFromElem(node)

  const placeholderID = node.dataset.termlyPlaceholderId

  if ( placeholderID ) {
    const placeholder = document.getElementById(placeholderID)

    if ( !placeholder ) {
      console.error('[Termly] Could not find placeholder matching selector %o',
                    placeholderID)

      return
    }

    return {
      hostname,
      placeholders: [placeholder],
    }
  }

  for ( const [domain, selector] of Object.entries(BLOCKED_CONTENT_NOTICE_SELECTORS) ) {
    if ( !isDomainMatch(domain, hostname) ) {
      continue
    }

    const placeholders = document.querySelectorAll(selector)

    if ( !placeholders.length ) {
      console.error('[Termly] Could not find placeholder elements matching %o',
                    selector)
      return
    }

    // Here, we return the domain instead of the hostname becuase
    // some scripts are known to introduce iframes and/or scripts
    // from other hosts in the same domain. E.g., when the user
    // temporarily unblocks www.easy-booking.at, an resource from
    // gsrv001.easy-booking.at will be introduced to the DOM,
    // which we also want to be unblocked so the user doesn't have
    // to grant consent in a chain of notices.
    //
    // It would be nice to be able to do this for all domains, but
    // the problem is that determining which part of a hostname is
    // the _domain_ is surprisingly difficult for some domains (e.g.,
    // www.ecatering.irctc.co.in)
    return {
      hostname: domain,
      placeholders: Array.from(placeholders),
    }
  }
}
